import { IUserTransaction } from '@/interfaces';
import ButtonLinkUser from '../ButtonLinkUser';
import { CoinAddedByEnum } from '@/enums';

type TProps = {
  transaction: IUserTransaction;
}

export const DataTableBodyCellDetailsAddedManually = ({ transaction }: TProps) => {

  if (transaction.options?.coinsAddedBy !== CoinAddedByEnum.MANUALLY) {
    return <></>;
  }

  return (
    <div className='flex items-center space-x-1 text-sm text-nowrap'>
      {
        transaction.options?.adminUserId &&
        <>
          <span>
            Ajouté par
          </span>
          <ButtonLinkUser userId={transaction.options.adminUserId} />
        </>
      }
    </div>
  );

};

export default DataTableBodyCellDetailsAddedManually;
